/**
 * Búsqueda tolerante de clientes (pantalla de Clientes y selector de cliente de los
 * pedidos). Ignora mayúsculas, acentos y la ñ SOLO al comparar (el nombre se muestra
 * tal cual), recorta y colapsa espacios, y busca también por teléfono comparando solo
 * dígitos (mínimo 3). Sin esto, "unai ibanez" o "Unai Iba " (con espacio al final) no
 * encontraban a UNAI IBAÑEZ y el operario acababa creando la ficha otra vez —
 * el origen de los clientes duplicados.
 */
export const normalizeText = (value) => (value || '')
  .toString()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

export const onlyDigits = (value) => (value || '').toString().replace(/\D/g, '');

export const MIN_PHONE_DIGITS = 3;

/**
 * @param {object} client
 * @param {string} searchTerm
 * @param {string[]} [fields] campos de texto donde buscar (además del teléfono)
 */
export const clientMatchesSearch = (client, searchTerm, fields = ['name', 'email']) => {
  const search = normalizeText(searchTerm);
  if (!search) return true;
  const digits = onlyDigits(searchTerm);
  return (
    fields.some((f) => normalizeText(client?.[f]).includes(search)) ||
    (digits.length >= MIN_PHONE_DIGITS && onlyDigits(client?.phone).includes(digits))
  );
};

export const filterClients = (clients, searchTerm, fields) =>
  (clients || []).filter((c) => clientMatchesSearch(c, searchTerm, fields));

export const VENTA_TIENDA = 'VENTA TIENDA';
export const esVentaTienda = (client) => (client?.name || '').trim().toUpperCase() === VENTA_TIENDA;

/**
 * Clientes que ofrece la calculadora en modo Venta tienda: los particulares MÁS la ficha
 * "VENTA TIENDA" (el cliente por defecto de mostrador), se la clasifique como se la
 * clasifique. Esa ficha tiene margen 70 (el de la tienda, a propósito) y por la regla
 * "el tipo lo manda el margen" es profesional, así que filtrar solo por tipo particular la
 * dejaba fuera: la calculadora arrancaba sin cliente y no dejaba añadir artículos.
 * Devuelve también la ficha VENTA TIENDA (o null) para preseleccionarla.
 */
export const clientesModoTienda = (clients) => {
  const lista = (clients || []).filter((c) => c?.clientType === 'particular' || esVentaTienda(c));
  return { clients: lista, ventaTienda: lista.find(esVentaTienda) || null };
};
